<template>
  <el-form label-width="80px" :model="formmodel">
    <el-form-item label="页面路径 "><el-input v-model="formmodel.url" @input="changeFunc"></el-input></el-form-item>
  </el-form>
</template>

<script>
  export default{
    data(){
      return {
        /*form模型*/
        formmodel: {
          name:'',
          url:''
        }
      }
    },
    methods:{
      /*选中的值*/
      changeFunc(e){
        let self = this;
        let params = {};
        params.name= "自定义链接";
        params.type= '自定义链接';
        params.url = self.formmodel.url;
        this.$emit('changeData',params);
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/DiyLink.vue